import { compose, lifecycle, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getShopAllowBookWithAnyBarber, getShops } from '../../shops/selectors';
import ShopList from '../../shops/components/ShopList';
import { fetchShopsById } from '../../shops/actions';
import { getBrandShops } from '../selectors';
import withExtensions from '../../extensions';
import { generateUrlString } from '../../utils/helpers';
import { SHOP_TYPE } from '../../constants';
import config from '../../../config';

const getUrlPattern = (shop) => {
  if (shop.kind === SHOP_TYPE.commision || getShopAllowBookWithAnyBarber(shop)) {
    return config.urlPatterns.booking;
  }
  return config.urlPatterns.barber;
};

const ShopsContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      brandRoute: ownProps.params.brandRoute,
      shopIds: getBrandShops(state, ownProps.params.brandRoute),
      shops: getShops(state),
      isLoading: state.shops.isFetching,
    }),
    { fetchShopsById },
  ),
  withExtensions,
  lifecycle({
    componentDidMount() {
      this.props.fetchExtension(this.props.brandRoute, true);
    },
  }),
  withPropsOnChange(
    ['shopIds'],
    (props) => {
      props.fetchShopsById(props.shopIds);
    }
  ),
  withPropsOnChange(
    ['shops'],
    async (props) => {
      // If there is only one shop we should redirect to that shop right away
      if (props.shops.length === 1) {
        const url = generateUrlString(
          { shopRoute: props.shops[0].route },
          getUrlPattern(props.shops[0])
        );
        props.router.push(url);
      }
    }
  ),
);

export default ShopsContainer(ShopList);



// WEBPACK FOOTER //
// ./src/app/brands/containers/Shops.jsx